import React, { Component } from 'react';
import { connect } from "react-redux";
import { debounce } from "lodash";

import axios from "axios";
import moment from "moment";
import { setList, setOverlay } from '../../Actions/stakeholderActions';
import { EditAction, ActionRejectUser, ActionAddMedia } from '../Common/Buttons/Icons';

//A React component will allow us to quickly iterate and change our code. It provides 
class MediaActionsComponent extends Component {
    constructor(props) {
        super(props);

        this.onMediaDismissHandler = debounce(this.onMediaDismissHandler.bind(this), 500);
    }

    onAddMediaHandler(e, props) {
        e.stopPropagation();
        this.toggleDropdown();

        var base_url = (this.props.match.url).split('/')
        this.props.history.push(this.props.match.url + '/media_modal/' + props.id + '/create');
    }

    onEditMediaHandler(e, props) {
        e.stopPropagation();
        this.toggleDropdown();

        this.props.history.push(this.props.match.url +  '/media_modal/' + props.media.ID + '/edit');
    }

    onMediaDismissHandler(e, props) {
        e.stopPropagation();
        this.toggleDropdown();
        var self = this;

        axios.get('/ajax/media_reminders/dismissSH/' + props.id)
        .then((response) => {
            var media_list = props.stakeholder.outstanding_media_list
            for (var i = 0; i < media_list.length; i++) {
                if (props.id === media_list[i].BOOK_ID) {
                    media_list.splice(i, 1);
                } 
            }

            props.dispatch(setList("SET_OUTSTANDING_MEDIA_LIST", media_list))
            
            axios({
                method: 'post',
                url: '/ajax/medialist/outstanding'
            })
            .then(function(response2) {
                props.dispatch(setList("SET_OUTSTANDING_MEDIA_LIST", response2.data.outstanding_bookings))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
            
            axios({
                method: 'post',
                url: '/ajax/medialist/dismissed'
            })
            .then(function(response2) {
                props.dispatch(setList("SET_DISMISSED_MEDIA_LIST", response2.data.dismissed_bookings))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })

            if ("vehicle" in props.stakeholder.current_vehicle_details && props.media.vehicle.V_ID === props.stakeholder.current_vehicle_details.vehicle.V_ID) {
                axios.get('/ajax/vehicle/' + props.media.vehicle.V_ID)
                .then(function(response2) {
                    props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }

            if ("profile" in props.stakeholder.current_profile_details && props.media.profile.ID === props.stakeholder.current_profile_details.profile.ID) {
                axios.get('/ajax/profile/' + props.media.profile.ID)
                .then(function(response2) {
                    props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }

            showStatusMsg(response?.data.message, 'success');
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })

        //props.onApproveHandler(e, props);
    }

    toggleDropdown() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');
    }

    render() {
        return (
            <div className = "button-group">
                {
                    this.props.add_button ?
                        <a className = "mr-8" data-tooltip tabIndex="1" title="Add Media" data-position="bottom" data-alignment="center" onClick={(e) => {this.onAddMediaHandler(e, this.props)}}>
                            {ActionAddMedia()}
                        </a>
                    :
                        <span />
                }

                {
                    this.props.edit_button ?
                        <a className = "float-right mr-8" data-tooltip tabIndex="1" title="Edit Media" data-position="bottom" data-alignment="center" onClick={(e) => {this.onEditMediaHandler(e, this.props)}} style= {{paddingTop:'2px'}}>
                            {EditAction()}
                        </a>
                    :
                        <span />
                }

                {
                    this.props.dismiss_button ?
                        <a data-tooltip tabIndex="1" title="Dismiss" data-position="bottom" data-alignment="center" onClick={(e) => {this.onMediaDismissHandler(e, this.props)}}>
                            {ActionRejectUser()}
                        </a>
                    :
                        <span />        
                }
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder
});

export default connect(mapStateToProps)(MediaActionsComponent);